import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClock = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 8.45833C0 3.78692 3.78692 0 8.45833 0C13.1297 0 16.9167 3.78692 16.9167 8.45833C16.9167 13.1297 13.1297 16.9167 8.45833 16.9167C3.78692 16.9167 0 13.1297 0 8.45833ZM9.29159 5.04169C9.29159 4.58145 8.91849 4.20835 8.45825 4.20835C7.99801 4.20835 7.62492 4.58145 7.62492 5.04169V9.13872C7.62492 9.5661 7.84327 9.96385 8.20382 10.1933L10.5473 11.6846C10.9356 11.9317 11.4506 11.8172 11.6977 11.4289C11.9448 11.0406 11.8304 10.5256 11.4421 10.2785L9.29159 8.90999V5.04169Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgClock);
export default ForwardRef;
